/**============================================================
*   [Class] 事業紹介：サービスリストスライダー
============================================================*/
export default class ServiceListSlider {
  constructor(
    target,
    key,
  )
  {
    this.swiperSlide = target;
    this.swiperKey = key;
    this.swiperSlide.classList.remove('swiper-disabled');
    this.swiperSlide.classList.add('swiper-'+ this.swiperKey);

    let swiperSlides = this.swiperSlide.getElementsByClassName('swiper-slide');
    let swiperSlideItemNum = swiperSlides.length;
    this.slidable = swiperSlideItemNum > this.swiperSlide.clientWidth/178;

    this.initSwiper = () => {
      this.mySwiper = new Swiper(this.swiperSlide, {
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        navigation: {
          nextEl: '.p-service-list-slide + .p-service-list-slide__buttons .swiper-button-next',
          prevEl: '.p-service-list-slide + .p-service-list-slide__buttons .swiper-button-prev',
        },
        watchOverflow: !this.slidable,
        loop: this.slidable,
        loopedSlides: 0,
        loopPreventsSlide: true,
      });
    };

    this.mySwiper = null;
    this.checkBreakpoint = (e) => {
      if(e.media == '(max-width: 767px)'){
        if (e.matches) {
          //SP:スライドつけない
          this.slidable = false;
          document.querySelector('.p-service-list-slide__buttons').classList.add('d-none');
          document.querySelector('.p-service-list-slide .swiper-wrapper').classList.add('justify-content-center');
          if(this.mySwiper){
            this.mySwiper.destroy(false, true);
            this.mySwiper = null;
          }
        }else if(!this.mySwiper){
          //PC:スライドつける
          if(swiperSlideItemNum > Math.floor(this.swiperSlide.clientWidth/178)){
            this.slidable = true;
            document.querySelector('.p-service-list-slide__buttons').classList.remove('d-none');
            document.querySelector('.p-service-list-slide .swiper-wrapper').classList.remove('justify-content-center');
            this.initSwiper();
          }
        }
      }else{
        if(swiperSlideItemNum > Math.floor(this.swiperSlide.clientWidth/178)){
          //スライドつける
          this.slidable = true;
          if(this.mySwiper == null){
            document.querySelector('.p-service-list-slide__buttons').classList.remove('d-none');
            document.querySelector('.p-service-list-slide .swiper-wrapper').classList.remove('justify-content-center');
            this.initSwiper();
          }
        }else {
          //スライドつけない
          this.slidable = false;
          document.querySelector('.p-service-list-slide__buttons').classList.add('d-none');
          document.querySelector('.p-service-list-slide .swiper-wrapper').classList.add('justify-content-center');
          if(this.mySwiper){
            this.mySwiper.destroy(false, true);
            this.mySwiper = null;
          }
        }
      }
    }

    //5個表示
    // @media (max-width: 1164px)
    this.mediaQueryPC1 = window.matchMedia('(max-width: 1164px)');
    this.mediaQueryPC1.addEventListener('change', this.checkBreakpoint, false);
    this.checkBreakpoint(this.mediaQueryPC1);

    //4個表示
    //@media (max-width: 986px)
    this.mediaQueryPC2 = window.matchMedia('(max-width: 986px)');
    this.mediaQueryPC2.addEventListener('change', this.checkBreakpoint, false);
    this.checkBreakpoint(this.mediaQueryPC2);

    //3個表示
    //@media (max-width: 808px)
    this.mediaQueryPC3 = window.matchMedia('(max-width: 808px)');
    this.mediaQueryPC3.addEventListener('change', this.checkBreakpoint, false);
    this.checkBreakpoint(this.mediaQueryPC3);

    //SP
    this.mediaQuerySP = window.matchMedia('(max-width: 767px)');
    this.mediaQuerySP.addEventListener('change', this.checkBreakpoint, false);
    this.checkBreakpoint(this.mediaQuerySP);

  }
}
